import { render, staticRenderFns } from "./BankruptcyComponent.vue?vue&type=template&id=f63d6b28"
import script from "./BankruptcyComponent.vue?vue&type=script&lang=js"
export * from "./BankruptcyComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports